<script setup>
import {computed, defineAsyncComponent, onMounted} from "vue"

const GameList = defineAsyncComponent(() => import("@shared/components/molecules/GameList.vue"))

import {useRoute} from "vue-router"

import {useGameStore} from "@shared/stores/GameStore"
import {useProvidersStore} from "@shared/stores/ProvidersStore"

const providersStore = useProvidersStore()
const gameStore = useGameStore()
const route = useRoute()

defineProps({
    filter: {
        type: String,
        default: ''
    }
})

const provider = computed(() => providersStore.providers.find(p => p.shortname === route.params.provider))

onMounted(() => {
    gameStore.fetchGames(true)
})
</script>

<template>
    <div id="casinogames" class="gamesblock">
        <h1>{{ provider.productRenamed }}</h1>
        <GameList
            :filter="filter"
            group="all"
            :product="provider.product"
            :display-amounts="{xl: 30, md: 20, sm: 12}"
        />
    </div>
</template>
